import React from 'react';
import Spinner from './spin.png';
import '../App.css';

const spinner = () => {
  return (
    <>
      <header className="spin-head">
        <img src={Spinner} alt="Loading..." className="spin-logo" />
      </header>
    </>
  );
};

export default spinner;
